import Organization from './organization-view'
export default Organization
